/**
 * Supabase Client for Browser/Client Components
 * Uses @supabase/ssr for proper cookie handling in Next.js App Router
 */

import { createBrowserClient } from "@supabase/ssr";
import { env } from "@/env.mjs";
import type { Database } from "./database.types";

export function createClient(): any {
  return createBrowserClient<Database>(
    env.NEXT_PUBLIC_SUPABASE_URL,
    env.NEXT_PUBLIC_SUPABASE_ANON_KEY
  );
}
